import { Flag, QualifiedFeature } from "./shared";
import { gql } from "apollo-boost";

const ReasoningFinding = gql`
  fragment ReasoningFinding on ClinicalReasoningFinding {
    id
    finding {
      ...QualifiedFeature
    }
    diseaseGivenFinding
    findingGivenDisease
    percentRange {
      min
      max
    }
    basedOnFindingGivenDisease
    isDirect
    absolutePredictiveValue
    diseaseIncidenceRate
    prevalence
    foundInPatient
    flags {
      ...Flag
    }
    noData
    redundantDueTo
    causality
    etgFindingGivenDisease
    etgDiseaseGivenFinding
    etgRiskFactor
    etgFindingGivenDiseaseBayes
    etiologySection
    percentExact
  }
  ${QualifiedFeature}
  ${Flag}
`;

export const Web_Solver = {
  DiseaseViewQuery: gql`
    query DV($qf: QualifiedFeatureInput, $filters: [QualifiedFeatureInput]) {
      diseaseView(
        qualifiedFeature: $qf
        qualifiedFeatureFilters: $filters
        depth: 3
        limit: 100
        maxGroupHeight: 3
      ) {
        disease {
          ...QualifiedFeature
          feature {
            children(depth: 1) {
              features {
                name
                id
              }
            }
            description {
              url
              text
            }
          }
        }
        prevalence
        prevalenceDescription
        incidence
        incidenceDescription
        citations
        categories {
          type
          findings {
            id
            complete
            parent {
              ...ReasoningFinding
            }
            children
            type
            category
            maxFindingGivenDisease
            maxAbsolutePredictiveValue
          }
        }
      }
    }
    ${ReasoningFinding}
    ${QualifiedFeature}
  `,
  DVOverviewQuery: gql`
    query DVOverview($f: ID!) {
      feature(id: $f) {
        name
        organSystem {
          id
          name
          shortname
        }

        subGroups {
          feature {
            name
            id
          }
          type
        }
        superGroups {
          feature {
            name
            id
          }
          type
        }

        description {
          url
          text
        }
      }
    }
  `,
};
